import Loading from "@/components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";

const ElectronicIndustry = dynamic(() => import("../../components/industries/Electronic/ElectronicIndustry"), {
   loading: () => <Loading />,
}
);

const MobileElectronicIndustry = dynamic(() => import("../../components/industries/Electronic/MobileElectronicIndustry"), {
   loading: () => <Loading />,
}
);

const Electronic = ({ mobileView }) => {
   return (
      <>
         <Head>
            <title>POS Billing Software for Electronics Store & Mobile Shops</title>
            <meta name="description" content="Efficient POS billing software tailored for electronics stores & mobile shops. Simplify transactions, manage inventory, and streamline sales. Get a Free Demo!"
            />
            <link rel="canonical" href="https://queuebuster.co/Industries/electronic-pos-billing-software" />
            <link rel="alternate" href="https://queuebuster.co/Industries/electronic-pos-billing-software" hrefLang="en-us" />
            <meta property="og:title" content="India's No.1 POS Billing Software for Electical & Electronics Stores - Get a Free Demo" />
            <meta property="og:description" content="Download QueueBuster POS billing software to manage mobile shops, electric shops, electronics showrooms, computer hardware, and home appliances with power packed features like billing, inventory, online dukaan, CRM, loyalty & many more." />
            <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images/OG_Electronics%2Bcopy%2B2.jpg" />
            <meta property="og:url" content="https://queuebuster.co/Industries/electronic-pos-billing-software" />
            
         </Head>
         <SchemaTags page="electronic-pos-billing-software" />
         {mobileView ? <MobileElectronicIndustry /> : <ElectronicIndustry />}
      </>
   );
};

export default Electronic;
